import { PackageOpen, Lock } from "lucide-react";

export default function Drop() {
  return (
    <div className="p-6 max-w-3xl space-y-5">
      <div>
        <h1 className="font-chivo text-3xl font-black tracking-tighter uppercase">Largage</h1>
        <p className="font-mono text-xs text-[#A3A3A3] mt-1">Module de largage de charge utile</p>
      </div>

      <div className="bg-[#141414] border border-[#F59E0B]/30 rounded-sm p-4 flex items-center gap-3">
        <Lock size={18} className="text-[#F59E0B]" />
        <span className="font-mono text-xs text-[#F59E0B]" data-testid="drop-disabled-message">Fonction largage non activée sur la V1.</span>
      </div>

      <div className="bg-[#141414] border border-white/10 rounded-sm p-6 space-y-4">
        <div className="flex items-center justify-center w-14 h-14 border border-white/10 rounded-sm mx-auto">
          <PackageOpen size={26} className="text-[#525252]" />
        </div>
        <div className="grid grid-cols-2 gap-3 max-w-md mx-auto">
          <button data-testid="btn-prepare-drop" disabled className="border border-white/15 rounded-sm font-mono text-xs uppercase py-3 opacity-30 cursor-not-allowed">Préparer largage</button>
          <button data-testid="btn-trigger-drop" disabled className="border border-[#EF4444]/40 text-[#EF4444] rounded-sm font-mono text-xs uppercase py-3 opacity-30 cursor-not-allowed">Déclencher largage</button>
        </div>
        <div className="font-mono text-[10px] text-[#525252] text-center space-y-1 pt-2">
          <div>Règles de sécurité (futur) : double confirmation obligatoire.</div>
          <div>Disponible uniquement si drone en mission livraison.</div>
          <div>Commande prévue : POST /drones/{"{drone_id}"}/command · {`{"command":"DROP","params":{"confirm":true}}`}</div>
        </div>
      </div>
    </div>
  );
}
